export const adminApiConfig = {
	apiVersion: "v3",
};